import { useSelector } from 'react-redux';

import useFetch from './useFetch';

const useFetchWithKey = (url, method = 'GET') => {
  const apiKey = useSelector(state => state.keys.key);
  const apiKeyOptions = {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': apiKey,
    },
    redirect: 'follow',
    referrer: 'no-referrer',
  };

  return useFetch(url, apiKeyOptions, '', false);
};

export default useFetchWithKey;
